<template>
  <Modal
      v-model="_value"
      width="500"
      title="部标1078视频指令"
      @on-visible-change="visibleChange"
      ok-text="关闭"
      cancel-text="">
    <Row>
      <Button size="small" type="primary" @click="onReqRealtimeAvTrans">请求实时音视频数据传输</Button>
    </Row>
    <Row style="margin-top: 5px;">
      <Button size="small" type="primary" @click="onCtrlRealtimeAvTrans">控制实时音视频数据传输</Button>
    </Row>
    <Row style="margin-top: 5px;">
      <Button size="small" type="primary" @click="onUploadAvFileToFtp">上传音视频文件到FTP</Button>
    </Row>
    <req-realtime-av-trans-modal v-model="reqRealtimeAvTransModal" :initValue="reqRealtimeAvTransId"></req-realtime-av-trans-modal>
    <make-av-file-upload-request-task-modal v-model="makeAvFileUploadRequestTaskModal" :initValue="makeAvFileUploadRequestTaskId"></make-av-file-upload-request-task-modal>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

import ReqRealtimeAvTransModal from '@/view/ddm/components/req-realtime-av-trans-modal'
import MakeAvFileUploadRequestTaskModal from '@/view/ddm/components/make-av-file-upload-request-task-modal'

export default {
  name: 'jt1078cmdmodal',
  components: { ReqRealtimeAvTransModal, MakeAvFileUploadRequestTaskModal },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      id: null,

      // 部标1078视频指令
      reqRealtimeAvTransModal: false,
      reqRealtimeAvTransId: null,

      makeAvFileUploadRequestTaskModal: false,
      makeAvFileUploadRequestTaskId: null
    }
  },
  methods: {
    ...mapActions([

    ]),
    visibleChange (val) {
      if (val) {
        this.id = this._initValue
      }
    },
    onReqRealtimeAvTrans () {
      this.reqRealtimeAvTransModal = true
      this.reqRealtimeAvTransId = this.id
    },
    onCtrlRealtimeAvTrans () {

    },
    onUploadAvFileToFtp () {
      this.makeAvFileUploadRequestTaskModal = true
      this.makeAvFileUploadRequestTaskId = this.id
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
